// export const ApiBaseUrl = "https://localhost:44306/"; // Local FastCare API URL
export const ApiBaseUrl = "https://fastcareapi.gentell.com/"; // Live Prodcution FastCare API URL
// export const ApiBaseUrl = "https://uat-fastcareapi.gentell.com/"; // Live UAT FastCare API URL
// export const ApiBaseUrl = "https://app-fastcare-dev-api.azurewebsites.net/"; // Live UAT FastCare API URL
// export const ApiBaseUrl = "https://gentellapi-restore-8a45.azurewebsites.net/"; // Live UAT FastCare API URL


//#region BlobStorage
// export const blobAccount = "gentellfastcarestorage";
export const blobAccount = "attachmentsfcprod";
// export const blobAccount = "stfastcareuatattachments"

// Current sas
export const blobSas =
    "?sp=racwl&st=2025-12-31T18:30:00Z&se=2026-12-31T18:29:59Z&sv=2024-11-04&sr=c&sig=MrF7V6XwX7e8fn9KCIlj4S6IiGpp%2Fikp3V8WfL8E0FM%3D";
    //sp=racwl&st=2025-12-31T18:30:00Z&se=2026-12-31T18:29:59Z&sv=2024-11-04&sr=c&sig=MrF7V6XwX7e8fn9KCIlj4S6IiGpp%2Fikp3V8WfL8E0FM%3D

// facilityreports
// export const blobSas =
//    "?sp=racwl&st=2026-02-02T18:30:00Z&se=2027-09-02T18:29:59Z&sv=2024-11-04&sr=c&sig=YuYG9BpMKQtqkejJNOPYpX2rhHaRg9HoYDjRymJHYBs%3D";

export const blobContainerName = "fcproduction";
// export const blobContainerName = "fcfacilityreports";

export const blobStorageUrl = `https://${blobAccount}.blob.core.windows.net`;
// export const blobStorageUrl = `https://${blobAccount}.blob.core.windows.net/fcproduction`;

//#endregion

export const defaultUrls = {
    defaultResidentPicture: "/template/media/images/nopatientpic.jpg",
    notificationHub: ApiBaseUrl + "NotificationHub",
};

export const apiUrls = {
    upsertResidentImage: ApiBaseUrl + "Resident/UpsertResidentImage",
    getallfacilitycontactsbyfacilityid:
        ApiBaseUrl + "FacilityContact/getallfacilitycontactsbyfacilityid",
    upsertfacilitycontact:
        ApiBaseUrl + "FacilityContact/upsertfacilitycontact",
    getvacationbyid: ApiBaseUrl + "Vacation/getvacationbyid",
    getallvacations: ApiBaseUrl + "Vacation/getallvacations",
    upsertvacation: ApiBaseUrl + "Vacation/upsertvacation",
    searcDoctors: "Physician/SearchDoctors",
    doctorsSearch: "Physician/DoctorsSearch",
    fetchPhysicianList: "Physician/FetchPhyList", 
    upsertPhysicianNew: "Physician/UpsertPhysicianFromGrid",

    SearchInsurance: ApiBaseUrl + "Resident/SearchInsurance",
    //User paths
    getAllUsers: "User/GetAllUser",
    getAllEMR: "Facility/GetEMR",
    upsertEMR: "Facility/UpsertEMR",
    fetchFacilityGroups: "Facility/FetchFacilityGroups",
    updateFacilityStatus: "Facility/UpdateFacilityStatus",
    updateResidentStatus: "Resident/UpdateResidentStatus",
    validateInsurance: "Resident/ValidateInsurance",
    updateResidentWoundStatus: "Wound/UpdateResidentWoundStatus",
    updateResidentWoundPartailStatus: "Process/UpdateResidentWoundPartailStatus",
    updateResidentWoundOrderNowStatus:
        "Process/UpdateResidentWoundOrderNowStatus",

    updateResidentWoundNoOrderStatus: "Process/UpdateResidentWoundNoOrderStatus",
    updateFacilityProcessor: "Process/UpdateFacilityProcessor",

    updateResidentNoOrderStatus: "resident/UpdateResidentNoOrderStatus",
    updateResidentECP: "resident/updateResidentECP",
    updateResidentHospice: "resident/updateResidentHospice",
    createWoundInfoChangeDetail: "wound/createWoundInfoChangeDetail",



    releaseFacilityPartailOrders: "Process/ReleaseFacilityPartailOrders",
    updateSkipOrHoldFacilityStatus: "Process/UpdateSkipOrHoldFacilityStatus",


    upsertFacilityUser: "Facility/UpsertFacilityUser",
    upsertFacilityClinician: "Facility/UpsertFacilityClinician",

    getFacilityUsers: "Facility/GetFacilityUsers",
    upsertResidentAOB: ApiBaseUrl + "Resident/UpsertAobForm",
    getFeatureSwitchEnabled: ApiBaseUrl + "/FeatureSwitch/feature/"
};
